'use client';

import { c as _c } from "react/compiler-runtime";
import { type CSSProperties, useContext } from 'react';
import type { SizesString } from '@/app/components/media/app-image/shared/image-size-types';
import { SPARTAN_PRODUCT_HERO_BANNER_ENGINE_LOGO_STRETCH_DURATION_MS } from '@/app/lcv/components/sections/spartan/products/hero-banner/constants';
import { SpartanProductHeroBannerEntranceContext } from '@/app/lcv/components/sections/spartan/products/hero-banner/entrance/context';
import type { SpartanProductHeroBannerStretchPixelConfig } from '@/app/lcv/components/sections/spartan/products/hero-banner/types';
import { SpartanStretchPixel } from '@/app/lcv/components/sections/spartan/shared/stretch-pixel';
import { SPARTAN_STRETCH_PIXEL_DEFAULT_DIRECTION, SPARTAN_STRETCH_PIXEL_DEFAULT_EASING } from '@/app/lcv/components/sections/spartan/shared/stretch-pixel/constants';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
interface SpartanProductHeroBannerEngineLogoStretchPixelProps {
  src: string;
  alt: string;
  width: number;
  height: number;
  sizes: SizesString;
  testId: string;
  config?: SpartanProductHeroBannerStretchPixelConfig;
}
interface EngineLogoMotionStyle extends CSSProperties {
  '--delay': string;
  '--easing': string;
}
export const SpartanProductHeroBannerEngineLogoStretchPixel = t0 => {
  const $ = _c(17);
  const {
    src,
    alt,
    width,
    height,
    sizes,
    testId,
    config
  } = t0;
  const isEntranceReady = useContext(SpartanProductHeroBannerEntranceContext);
  const direction = config?.direction ?? SPARTAN_STRETCH_PIXEL_DEFAULT_DIRECTION;
  const durationMs = config?.durationMs ?? SPARTAN_PRODUCT_HERO_BANNER_ENGINE_LOGO_STRETCH_DURATION_MS;
  const easing = config?.easing ?? SPARTAN_STRETCH_PIXEL_DEFAULT_EASING;
  const t1 = config?.delayMs === undefined ? "var(--spartan-hero-motion-delay-engine-logo)" : `${config.delayMs}ms`;
  const t2 = config?.easing ?? "var(--spartan-hero-motion-ease-movement)";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = {
      "--delay": t1,
      "--easing": t2
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const motionStyle = t3;
  const t4 = isEntranceReady ? 1 : 0;
  let t5;
  if ($[3] !== testId) {
    t5 = createDataAttributes({
      test: testId
    });
    $[3] = testId;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== alt || $[6] !== direction || $[7] !== durationMs || $[8] !== easing || $[9] !== height || $[10] !== motionStyle || $[11] !== sizes || $[12] !== src || $[13] !== t4 || $[14] !== t5 || $[15] !== width) {
    t6 = <SpartanStretchPixel src={src} alt={alt} width={width} height={height} progress={t4} animateProgress={true} direction={direction} durationMs={durationMs} delayMs={0} easing={easing} style={motionStyle} intrinsicAspect={false} objectFit="contain" objectPosition="center" sizes={sizes} loading="eager" {...t5} />;
    $[5] = alt;
    $[6] = direction;
    $[7] = durationMs;
    $[8] = easing;
    $[9] = height;
    $[10] = motionStyle;
    $[11] = sizes;
    $[12] = src;
    $[13] = t4;
    $[14] = t5;
    $[15] = width;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};